import { Component } from '@angular/core';

/**
 * Demonstate the usage of {@link EditorComponent}
 */
@Component({
  templateUrl: './editor-demo.component.html',
  styleUrls: ['./editor-demo.component.scss'],
})
export class EditorDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/editor/editor-demo.component.ts